module.exports = __webpack_public_path__ + "static/media/receipt_bottom.8a81addd.png";